// src/stores/auth.js
import { defineStore } from 'pinia'
import { api, api_simple } from '../utils/axios'
import { authEvents } from '../eventBus'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    username: null,
    display_name: null,
    groupname: null,
    isAdmin: false,
    isAuthenticated: false,
    loading: false,
    avatarURL: 'ahoj',
  }),

  getters: {
    // Přidáme getter pro snadnější kontrolu přihlášení
    isLoggedIn: (state) => state.isAuthenticated && state.username !== null,
  },

  actions: {
    init() {
      authEvents.addEventListener('auth:swlogout', () => {
        this.swlogout()
      })
    },

    async login(username, password) {
      this.loading = true
      try {
        const response = await fetch('/api/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Důležité pro cookies
          body: JSON.stringify({ username, password }),
        })

        if (!response.ok) {
          const error = await response.json()
          throw new Error(error.msg || 'Login failed')
        }

        const data = await response.json()
        this.username = data.username
        this.display_name = data.display_name
        this.groupname = data.groupname
        this.isAdmin = data.is_admin
        this.isAuthenticated = true

        return true
      } catch (error) {
        console.error('Login failed:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async swlogout() {
      this.username = null
      this.isAuthenticated = false
    },

    async logout() {
      if (!(await this.checkAuth())) {
        return true
      }
      try {
        const step1 = await api_simple.post('/remove_access')
        const step2 = await api_simple.post('/remove_refresh')
        if (step1 && step2) {
          this.swlogout()
          return true
        }
      } catch (error) {
        console.error('Logout failed:', error)
      }
      return false
    },

    async checkAuth() {
      try {
        const response = await api.get('/check-auth')
        this.username = response.data.username
        this.display_name = response.data.display_name
        this.groupname = response.data.groupname
        this.isAdmin = response.data.is_admin
        this.isAuthenticated = true
        return true
      } catch (error) {
        this.username = null
        this.display_name = null
        this.groupname = null
        this.isAuthenticated = false
        return false
      }
    },

    async getAvatarURL() {
      const response = await api.get(`/avatar/${this.username}`)
      this.avatarURL = response.data + '?t=' + Date.now()
      return response.data
    },

  },
})
